import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";

const LeaveNavBarItems = () => {
  const location = useLocation();
  const DynamicMenu = JSON.parse(
    localStorage.getItem("DynamicMenuJson" || "{}")
  );
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  // const [dynamicMenuList, setDynamicMenuList] = useState({});
  // const featureConfig = {}
  // useEffect(() => {
  //   if (DynamicMenu?.EmployeeFunctionalityGroups?.length > 0) {
  //     setDynamicMenuList(
  //       DynamicMenu?.EmployeeFunctionalityGroups?.find((el) => el?.Code == "LV")
  //     );
  //   }
  //   if (userDetails?.DirectReporteeCount==0) {
  //     featureConfig = {
  //       "LV-008": {
  //         route: "/Calendar",
  //         defaultIcon: "/images/menu-icon/DashboardIcon.svg",
  //       },
  //       "LV-001": {
  //         route: "/LeaveDashboard",
  //         defaultIcon: "/images/menu-icon/DashboardIcon.svg",
  //       },
  //       "LV-002": {
  //         route: "/Leave",
  //         defaultIcon: "/images/org-img/leave/my-leave.svg",
  //       },
  //       "LV-003": {
  //         route: "/OrganizationLeave",
  //         defaultIcon: "/images/menu-icon/org-leaves.svg",
  //       },
  //       "LV-005": {
  //         route: "/TeamLeave",
  //         defaultIcon: "/images/org-img/leave/team-leaves.svg",
  //       },
  //       "LV-004": {
  //         route: "/MyLedger",
  //         defaultIcon: "/images/menu-icon/ledger.svg",
  //       },
  //       "LV-006": {
  //         route: "/ApplyForOther",
  //         defaultIcon: "/images/org-img/leave/apply-forother.svg",
  //       },
  //       "LV-007": {
  //         route: "/LeaveAdjustment",
  //         defaultIcon: "/images/org-img/leave/leave-adj.svg",
  //       },
  //     };
  //   }else {
  //       featureConfig = {
  //       "LV-008": {
  //         route: "/Calendar",
  //         defaultIcon: "/images/menu-icon/DashboardIcon.svg",
  //       },
  //       "LV-001": {
  //         route: "/LeaveDashboard",
  //         defaultIcon: "/images/menu-icon/DashboardIcon.svg",
  //       },
  //       "LV-002": {
  //         route: "/Leave",
  //         defaultIcon: "/images/org-img/leave/my-leave.svg",
  //       },
  //       "LV-003": {
  //         route: "/OrganizationLeave",
  //         defaultIcon: "/images/menu-icon/org-leaves.svg",
  //       },       
  //       "LV-004": {
  //         route: "/MyLedger",
  //         defaultIcon: "/images/menu-icon/ledger.svg",
  //       },
  //       "LV-007": {
  //         route: "/LeaveAdjustment",
  //         defaultIcon: "/images/org-img/leave/leave-adj.svg",
  //       },
  //     };
  //   }
  // }, []);


  const [dynamicMenuList, setDynamicMenuList] = useState({});
  const [featureConfig, setFeatureConfig] = useState({});

  useEffect(() => {
    if (DynamicMenu?.EmployeeFunctionalityGroups?.length > 0) {
      setDynamicMenuList(
        DynamicMenu.EmployeeFunctionalityGroups.find((el) => el?.Code === "LV")
      );
    }

    // if (userDetails?.DirectReporteeCount != 0) {
    //   setFeatureConfig({
    //     "LV-008": {
    //       route: "/Calendar",
    //       defaultIcon: "/images/menu-icon/DashboardIcon.svg",
    //     },
    //     "LV-001": {
    //       route: "/LeaveDashboard",
    //       defaultIcon: "/images/menu-icon/DashboardIcon.svg",
    //     },
    //     "LV-002": {
    //       route: "/Leave",
    //       defaultIcon: "/images/org-img/leave/my-leave.svg",
    //     },
    //     "LV-003": {
    //       route: "/OrganizationLeave",
    //       defaultIcon: "/images/menu-icon/org-leaves.svg",
    //     },
    //     "LV-005": {
    //       route: "/TeamLeave",
    //       defaultIcon: "/images/org-img/leave/team-leaves.svg",
    //     },
    //     "LV-004": {
    //       route: "/MyLedger",
    //       defaultIcon: "/images/menu-icon/ledger.svg",
    //     },
    //     "LV-006": {
    //       route: "/ApplyForOther",
    //       defaultIcon: "/images/org-img/leave/apply-forother.svg",
    //     },
    //     "LV-007": {
    //       route: "/LeaveAdjustment",
    //       defaultIcon: "/images/org-img/leave/leave-adj.svg",
    //     },
    //   });
    // } else {
    //   setFeatureConfig({
    //     "LV-008": {
    //       route: "/Calendar",
    //       defaultIcon: "/images/menu-icon/DashboardIcon.svg",
    //     },
    //     "LV-001": {
    //       route: "/LeaveDashboard",
    //       defaultIcon: "/images/menu-icon/DashboardIcon.svg",
    //     },
    //     "LV-002": {
    //       route: "/Leave",
    //       defaultIcon: "/images/org-img/leave/my-leave.svg",
    //     },
    //     "LV-003": {
    //       route: "/OrganizationLeave",
    //       defaultIcon: "/images/menu-icon/org-leaves.svg",
    //     },
    //     "LV-004": {
    //       route: "/MyLedger",
    //       defaultIcon: "/images/menu-icon/ledger.svg",
    //     },
    //     "LV-007": {
    //       route: "/LeaveAdjustment",
    //       defaultIcon: "/images/org-img/leave/leave-adj.svg",
    //     },
    //   });
    // }


    const baseConfig = {
      "LV-008": {
        route: "/LeaveDashboard/Calendar",
        defaultIcon: "/images/menu-icon/DashboardIcon.svg",
      },
      "LV-001": {
        route: "/LeaveDashboard",
        defaultIcon: "/images/menu-icon/DashboardIcon.svg",
      },
      "LV-002": {
        route: "/Leave",
        defaultIcon: "/images/org-img/leave/my-leave.svg",
      },
      "LV-003": {
        route: "/OrganizationLeave",
        defaultIcon: "/images/menu-icon/org-leaves.svg",
      },
      "LV-004": {
        route: "/MyLedger",
        defaultIcon: "/images/menu-icon/ledger.svg",
      }

    };

    const extraConfig = {
      "LV-005": {
        route: "/TeamLeave",
        defaultIcon: "/images/org-img/leave/team-leaves.svg",
      },
      "LV-006": {
        route: "/ApplyForOther",
        defaultIcon: "/images/org-img/leave/apply-forother.svg",
      },
      "LV-007": {
        route: "/LeaveAdjustment",
        defaultIcon: "/images/org-img/leave/leave-adj.svg",
      },
    };

    if (userDetails?.DirectReporteeCount != 0) {
      setFeatureConfig({ ...baseConfig, ...extraConfig });
    } else {
      setFeatureConfig(baseConfig);
    }
  }, []);





  const moreFeatures = ["LV-004", "LV-006", "LV-007"];
  return (
    <div>
      <div className="rightside-tabs">
        {dynamicMenuList?.EmployeeFunctionalityList?.map((timeOff, index) => {
          const config = featureConfig[timeOff.Code];
          const isActive = location?.pathname === config?.route;

          // Skip items meant for "More" menu
          if (moreFeatures.includes(timeOff.Code)) {
            return null;
          }

          if (config) {
            return (
              <div className="me-auto" key={index}>
                <Link to={config.route}>
                  <h2
                    className={`font-w600 mb-0 ${isActive ? "h2active" : ""}`}
                  >
                    <img
                      src={timeOff?.IconPath || config.defaultIcon}
                      style={{ backgroundColor: timeOff?.Color }}
                    />
                    {timeOff?.FeatureName}
                  </h2>
                </Link>
              </div>
            );
          }
          return null;
        })}

        {/* "More" Menu */}
        <div className="me-auto">
          <ul style={{ cursor: "pointer" }}>
            <li className="nav-item dropdown notification_dropdown">
              <a
                className="nav-link p-0 moremenudropdown"
                data-bs-toggle="dropdown"
                href="#"
              >
                <img
                  src="/images/menu-icon/MoreIcon.svg"
                  style={{ width: "16px", marginRight: "6px" }}
                  alt="More"
                />
                More
              </a>
              <div className="dropdown-menu dropdown-menu-end">
                <ul className="timeline">
                  {dynamicMenuList?.EmployeeFunctionalityList?.map((timeOff, index) => {
                    const config = featureConfig[timeOff.Code];
                    const isActive = location?.pathname === config?.route;

                    if (moreFeatures.includes(timeOff.Code) && config) {
                      return (
                        <li className="mb-0" key={index}>
                          <Link
                            to={config.route}
                            className={`timeline-panel text-muted d-inline-flex profiledrop2 p-0 ${isActive ? "h1active" : ""}`}
                          >
                            <img
                              src={timeOff?.IconPath || config.defaultIcon}
                              style={{ width: "14px", marginRight: "6px" }}
                              alt={timeOff?.FeatureName}
                            />
                            {timeOff?.FeatureName}
                          </Link>
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default LeaveNavBarItems;
